export const removeWhiteSpaces = (str: string) => {
  return str.replace(/\s/g, "_");
};

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
